import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/common';
import { UserMentoringTaskDetail } from '@pt/models';

import { DialogData } from '../abstructions/task-details-base.component';
import { MentoringTaskDetailsComponent } from './mentoring-task-details.component';

@Injectable()
export class MentoringTaskDetailsDialog {
  readonly #dialog = inject(DialogService);

  open(taskData: DialogData<UserMentoringTaskDetail>): DialogRef {
    return this.#dialog.open(MentoringTaskDetailsComponent, taskData);
  }
}
